/**
 * @typedef {Object} RestrictionsTimeSettings
 * @property {Dates} dates - Объект с диапазоном дат.
 * @property {timezoneInfo} timezoneInfo - Данные об таймзонах
 * @property {string} lang - Данные об локали
 */
import { I18n } from "~/js/tools/i18n";

/**
 * @param container {Element}
 * @param settings {RestrictionsTimeSettings}
 * */
function hasTimeLimit(container, settings) {
  const {
    msg,
    className
  } = checkDates(settings.dates.from, settings.dates.to, settings.lang);
  container.classList.add("qform-has-time-limit");
  className && container.classList.add(className);
  container.innerHTML = `<i></i><span>${msg} (${settings.timezoneInfo?.short})</span>`;
}

/**
 * @param from {number | Date} - Время начала работы формы
 * @param to {number | Date} - Время конца работы формы
 * @param lang {string} - ru | en
 * */
function checkDates() {
  let from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  let to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  let lang = arguments.length > 2 ? arguments[2] : undefined;
  const $i18n = new I18n(lang);
  const now = new Date(); // Текущее время
  const startMoment = new Date(from); // Начало диапазона
  const endMoment = new Date(to); // Конец диапазона

  if (now < startMoment) {
    // Если текущее время меньше начального времени
    return {
      msg: $i18n.t('restrictions.hasTimeLimit.ResponsesAreAcceptedWith', {
        date: formatDate(startMoment, lang)
      }),
      className: "--early"
    };
  } else if (now > endMoment) {
    // Если текущее время больше конечного времени
    return {
      msg: $i18n.t('restrictions.hasTimeLimit.ResponsesWereAcceptedBefore', {
        date: formatDate(endMoment, lang)
      }),
      className: "--late"
    };
  } else {
    // Если текущее время находится в диапазоне
    return {
      msg: $i18n.t('restrictions.hasTimeLimit.ResponsesAreAcceptedUntil', {
        date: formatDate(endMoment, lang)
      }),
      className: ""
    };
  }
}

/**
 * @param date {Date}
 * @param locale {string}
 * */
function formatDate(date) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ru-Ru";
  // Получаем отформатированную дату и время
  const formattedDate = date.toLocaleString(locale, {
    month: "long",
    day: "numeric"
  });
  const formattedTime = date.toLocaleString(locale, {
    hour: "2-digit",
    minute: "2-digit"
  });
  return `${formattedDate} ${formattedTime}`;
}
export default hasTimeLimit;